import { createClient } from 'contentful';

const SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID || '53gjuiuzgl45';
const ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN || '4716d74130da4568f1a920e0d1a44e6a676179436de27eb3fb5c833bb7eafc0e';
const HOST = process.env.REACT_APP_CONTENTFUL_HOST || 'cdn.contentful.com';

const client = createClient({
  space: SPACE_ID,
  accessToken: ACCESS_TOKEN,
  host: HOST,
});

// get navigation
export const getNavi = (locale) => client.getEntries({
  content_type: 'navigation',
  limit: 1,
  include: 2,
  locale,
  select: [
    'fields.entries',
  ],
})
.then(response => response.items[0].fields.entries)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

export const getPage = (slug, locale) => client.getEntries({
  content_type: 'page',
  'fields.slug': slug,
  include: 2,
  locale,
  select: [
    'fields.slug',
    'fields.title',
    'fields.elements',
  ],
})
.then(response => response.items[0].fields)
.catch(error => {
  console.log('error occured')
  console.log(error)
});


export const getReservationTexts = (locale) => client.getEntries({
  content_type: 'reservationTexts',
  limit: 1,
  locale,
  select: [
    'fields.backgroundImage',
    'fields.onlineBookingInfo',
    'fields.groupReservationInfo'
  ]
})
.then(response => ({
  ...response.items[0].fields
}))
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get open hours
export const getHours = (locale) => client.getEntries({
  content_type: 'contactUs',
  limit: 1,
  locale,
  select: [
    'fields.openingHours'
  ]
})
.then(response => response.items[0].fields.openingHours)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get front page
export const getFront = (locale) => client.getEntries({
  content_type: 'frontPage',
  limit: 1,
  locale,
  include: 10,
  select: [
    'fields.header',
    'fields.lifts',
    'fields.showLiftsHeading',
    'fields.containers',
    'fields.contactPage'
  ]
})
.then(response => {
  return {
    "header":response.items[0].fields.header.fields,
    "lifts":response.items[0].fields.lifts,
    "showLiftsHeading":response.items[0].fields.showLiftsHeading,
    "containers":response.items[0].fields.containers,
    "contactPage":response.items[0].fields.contactPage
  }
})
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get Menus
export const getMenus = (locale) => client.getEntries({
  content_type: 'menu',
  order: 'fields.order',
  locale,
  include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get open hours
export const getContact = (locale) => client.getEntries({
  content_type: 'contactUs',
  limit: 1,
  include: 2,
  locale,
  select: [
    'fields.header',
    'fields.leftColumn',
    'fields.rightColumn'
  ]
})
.then(response => {
  return {
  "header":response.items[0].fields.header.fields,
  "leftColumn":response.items[0].fields.leftColumn,
  "rightColumn":response.items[0].fields.rightColumn
}})
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get Blogs
export const getBlogs = (locale, limit = 1, offset = 0) => client.getEntries({
  content_type: 'blogPost',
  order: '-fields.published',
  limit: limit,
  skip: offset,
  locale,
  include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});



// WEBPACK FOOTER //
// ./src/api/contentfulAPI.js